var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 49 10 C 41.28 10 35 16.28 35 24 L 35 28 L 18 28 C 13.582 28 10 31.582 10 36 L 10 52 C 10 56.418 13.582 60 18 60 L 40 60 C 44.418 60 48 56.418 48 52 L 48 36 C 48 32.643974 45.930202 29.775473 43 28.587891 L 43 24 C 43 20.691 45.691 18 49 18 C 52.309 18 55 20.691 55 24 L 55 32 C 55 34.209 56.791 36 59 36 C 61.209 36 63 34.209 63 32 L 63 24 C 63 16.28 56.72 10 49 10 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.596da4dc2141270d824970db0bbf40db.svg";
export { ForwardRef as ReactComponent };